export default "__VITE_ASSET__CeMxc8XO__"